import { useLocale, useTranslations } from "next-intl";
import { css } from "styled-system/css";

import { NumberFormatter } from "@/utils/number-formatter";

import { bannerAmountStyles, bannerCardStyles, bannerLabelStyles } from "./banner-card-styles";

interface YtdCardProps {
  yearToDateUsd: number;
  weeklyWowPct: number | undefined;
}

export function YtdCard({ yearToDateUsd, weeklyWowPct }: YtdCardProps) {
  const t = useTranslations("rewards");
  const locale = useLocale();
  const amount = NumberFormatter.compactHeading(yearToDateUsd, { currency: true, locale });
  const wowLabel =
    weeklyWowPct !== undefined
      ? t.rich("banner.wowLabel", {
          pct: formatWholePercent(weeklyWowPct, locale),
          color: (chunks) => (
            <span className={weeklyWowPct > 0 ? positivePctStyles : undefined}>{chunks}</span>
          ),
        })
      : null;

  return (
    <div className={bannerCardStyles}>
      <div className={bannerLabelStyles}>{t("banner.yearToDate")}</div>
      <div className={bannerAmountStyles}>{amount}</div>
      {wowLabel !== null && <div className={subLabelStyles}>{wowLabel}</div>}
    </div>
  );
}

function formatWholePercent(pct: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: "percent",
    signDisplay: "exceptZero",
    maximumFractionDigits: 0,
  }).format(pct / 100);
}

const subLabelStyles = css({ mt: "16", textStyle: "highlight.md", color: "text.disabled" });

const positivePctStyles = css({ color: "text.positiveBright" });
